import * as actions from '../actions';
import * as srv from '../services'
import {ActionTypes} from '../constants/ActionTypes';
import {put, call, fork, take, select, takeEvery, cancel} from 'redux-saga/effects';
import {getStateUser} from '../reducers/getstate';
import {selectToken} from '../reducers/selectors';
import {push} from 'react-router-redux';
import {browserHistory} from 'react-router';
import createBrowserHistory from 'history/createBrowserHistory';

//Config locate
import moment from 'moment';
import 'moment/locale/vi';

moment.locale('vi');

let customProjects = [{
    id: 63,
    name: 'BẢO TRÌ THIẾT BỊ',
    description: 'bảo hành, bảo trì thiết bị iTracking',
    logo: 'http://itracking.vn/images/logo.png',
    logoName: 'iTracking'
},
    {
        id: 65,
        name: 'SMARTBIKE - BẢO TRÌ THIẾT BỊ',
        description: 'bảo hành, bảo trì thiết bị SmartBike',
        logo: 'http://smartbike.vn/public/images/Ui-new/logo_smartbike.png',
        logoName: ''
    }];

export function* createUser() {
    while (true) {
        try {
            yield take(ActionTypes.CREATE_USER);
            const user = yield select(getStateUser);
            const msgUser = yield call(srv.postCreateUser, user);
            if (msgUser.data.msg === true) {
                if (msgUser.data.users.projectId === 63) {
                    yield put(actions.selectUser([msgUser.data.users]));
                }
            } else {
                yield cancel(msgUser);
            }
        } catch (error) {
        }
    }
}

export function* editUser() {
    while (true) {
        try {
            yield take(ActionTypes.EDIT_USER);
            const user = yield select(getStateUser);
            const msgUser = yield call(srv.postUpdateUser, user);
            if (msgUser.data.msg === true) {
                yield put(actions.editUser(msgUser.data, msgUser.data.msg));
            } else {
                yield cancel(msgUser);
            }
        } catch (error) {
        }
    }
}

export function* deleteUser() {
    while (true) {
        try {
            yield take(ActionTypes.DELETE_USER);
            const userID = yield select(getStateUser);
            const msgUser = yield call(srv.postDeleteUser, userID);
            if (msgUser.data.msg === true) {
                yield put(actions.deleteUser(msgUser.data.userId, msgUser.data.msg));
            } else {
                yield cancel(msgUser);
            }
        } catch (error) {
        }
    }
}

export function* login() {
    while (true) {
        try {
            yield take(ActionTypes.LOGIN);
            const user = yield select(getStateUser);
            const msgUser = yield call(srv.postLogin, user);

            if (msgUser.data.token !== "" && msgUser.status === 200) {
                yield put(actions.getToken(msgUser.data.token));
                yield put(actions.login(msgUser.data.data));
            } else {
                yield cancel(msgUser);
            }
        } catch (error) {
            yield put(actions.errorsMsg(true, "Tên đăng nhập hoặc mật khẩu không đúng", ActionTypes.ERROR_MSG));
        }
    }
}

export function* listenReadUsers(action) {
    const {users, query} = action;
    try {
        if (query) {
            const data = yield call(srv.readUsers, 'read/' + query);
            if (data.users) {
                yield put(actions.selectUser(data.users));
                yield put(actions.selectUserMap(data.users));
            } else {
                yield cancel(data);
            }
        }
    } catch (error) {
        console.log('Read user error:', error);
    }
}

export default function* root() {
    yield [
        fork(login),
        fork(createUser),
        fork(deleteUser),
        fork(editUser),
        takeEvery(ActionTypes.SELECT_USER, listenReadUsers),
    ]
}


// WEBPACK FOOTER //
// ./src/saga/index.js